import {Middleware} from '@reduxjs/toolkit'

import {Sentry} from '@web/helpers/log'

import {ResultRootState as State} from '../../../interfaces'

const sentryTransaction: Middleware<object, State> =
    ({getState}) =>
    (next) =>
    (action) => {
        const nextState = getState()

        Sentry.setTags({
            seqId: nextState.common.seqID,
            scheduleId: nextState.admissionDetail.usedPaymentMethod.subscription?.scheduleId,
            deliveryId: nextState.admissionDetail.usedPaymentMethod.subscription?.id,
        })

        next(action)
    }

export default sentryTransaction
